// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"883":"component---src-pages-404-js","924":"component---src-templates-main-js"}[chunkId] + "-" + {"883":"7891bb1395170f8c187e","924":"0ff9813fa6dc549f6678"}[chunkId] + ".js";
};